<navaar-header
    [color]="'transparent'"
    [z-index]="2"
    [title]="model?.title"
>
</navaar-header>
<div
    *ngIf="model"
    id="blured-cover"
    [ngStyle]="{backgroundImage: setBackground(model.image, model.recordVersion)}"
></div>
<div *ngIf="model">
    <div class="container-pdp">
        <div id="container-cover">
            <div class="wrapper-cover">
                <img
                    [lazySrc]="environment.imageUrl + '/content/artists/' + model.image + '/pic.jpg?t=' + model.recordVersion + '&w=512&h=512'"
                    class="wrapper-img-slider"
                    src="assets/img/placeholder.png"
                    lazySrcVisible="visible"
                    loading="lazy"
                >
            </div>
        </div>
    </div>
    <div
        #containerScroll
        class="container-scroll-div"
    >
        <div class="wrapper-scroll-div">
            <div class="container-title">
                <div class="wrapper-title">
                    <h2
                        style="padding-top: 0px;"
                        [textContent]="model.title"
                    ></h2>
                    <span [textContent]="model.artistType"></span>
                </div>
            </div>
            <div class="wrapper-info">
                <div class="container-artist-info">
                    <div>
                        <p>
                            <span [textContent]="model.totalBook"></span>
                            عدد
                        </p>
                        <p>محتوای صوتی</p>
                    </div>
                    <span>|</span>
                    <div>
                        <p>
                            <span [textContent]="model.totalTimes"></span>
                            ساعت
                        </p>
                        <p>مجموع ساعت</p>
                    </div>
                </div>
            </div>
            <div id="section-description">
                <h2>زندگی نامه</h2>
                <p
                    class="wrapper-description"
                    [innerHtml]="model.shortDesc"
                >
                </p>
                <span
                    class="more-text-style"
                    (click)="showDescription()"
                >
                    ادامه مطلب...
                </span>
            </div>
        </div>
        <div class="container-sliders">
            <navaar-list-items
                *ngIf="books?.length > 0"
                [items]="books"
                [title]="'آثار صوتی'"
                [isEnd]="isEnd"
                (go-to)="goToPage($event)"
                [disable-when-fetch-data]="isLoading"
                [detail-mode]="false"
                [type]="'star'"
                [more-icon]="false"
            >
            </navaar-list-items>
        </div>
    </div>
</div>
<navaar-container-scroll
    [title]="model.title"
    [showHeader]="true"
    (close)="closeDescPopup($event)"
    [show]="isShowDescription"
    *ngIf="model"
>
    <navaar-tabs-scroll-spy>
        <navaar-tab-scroll-spy
            [title]="'زندگی نامه'"
            [en-title]="'desc'"
            [attr.id]="'description-audiobook'"
            [id]="'description-audiobook'"
        >
            <p
                id="description-artist-style"
                [innerHTML]="model.bio"
            ></p>
        </navaar-tab-scroll-spy>
    </navaar-tabs-scroll-spy>
</navaar-container-scroll>
